import { useSquash } from '@src/hooks/useSquash';
import bg_1_intro from '../../public/assets/highRes/1_bg.png';
import bg_1 from '../../public/assets/highRes/1_extended.jpg';
import bg_2 from '../../public/assets/highRes/2_extended.jpg';
import bg_3 from '../../public/assets/highRes/3_extended.jpg';
import bg_4 from '../../public/assets/highRes/4_extended.jpg';
import bg_5 from '../../public/assets/highRes/5_extended.jpg';
import { useState, useEffect, useRef } from 'react';
import useWindowDimensions from '@src/hooks/useWindowDimensions';

const backgroundImages = [bg_1_intro, bg_1, bg_2, bg_3, bg_4, bg_5];

export const BackgroundHighRes = ({ isIntro }: { isIntro?: boolean }) => {
  const { activeSquash } = useSquash();
  const { height } = useWindowDimensions();
  const [isAnimating, setIsAnimating] = useState(false);

  const prevLevelRef = useRef(activeSquash?.onChainLevel ?? 0);

  useEffect(() => {
    const currentLevel = activeSquash?.onChainLevel ?? 0;

    // show animation if level increased
    if (currentLevel > prevLevelRef.current) {
      setIsAnimating(true);
      setTimeout(() => {
        setIsAnimating(false);
      }, 1000);
    }

    prevLevelRef.current = currentLevel;
  }, [activeSquash?.onChainLevel]);

  // If in intro mode, always show level 0 background
  const displayLevel = Math.min(
    isIntro ? 0 : (activeSquash?.onChainLevel ?? 0) + 1,
    5
  );
  const image = backgroundImages[displayLevel];

  if ((!isIntro && !activeSquash) || !image) {
    return null;
  }

  return (
    <div className='absolute inset-0 h-full w-full'>
      <div
        className={`absolute inset-0 bg-white transition-opacity duration-1000 ${
          isAnimating ? 'opacity-100' : 'opacity-0'
        }`}
      />
      <img
        src={image}
        className={`h-full w-full object-cover transition-opacity duration-1000 ${
          isIntro
            ? height < 750
              ? 'object-[center_80%]'
              : 'object-bottom'
            : 'object-cover'
        } ${isAnimating ? 'opacity-0' : 'opacity-100'}`}
        alt='background'
      />
    </div>
  );
};
